import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { PiSpinner } from 'react-icons/pi';
import { MdErrorOutline } from 'react-icons/md';

import {  BaIconCheckCircle } from 'components/ui/icons';
import { getFormattedPrice } from 'components/utils/string';
import GiftCardImage from 'components/gift-card-image';

import { useQueryDict } from 'hooks/app';

import { bdayFetch } from 'services/utils';

import './styles.scss';

const CardCreateRecipientGiftCard = ({ className, cardSend, cardSendRecipient, giftCard }) => {
  const { updateSearch } = useQueryDict();
  const pollingRef = useRef();

  const { cardSendId } = cardSend;
  const { cardSendRecipientId } = cardSendRecipient;
  const { productPrice, productRetailerName, jifitiCardId, currencyCode } = giftCard;

  const [status, setStatus] = useState(giftCard.status);

  useEffect(() => {
    if (status === 'pending') {
      checkStatusChange();
      pollingRef.current = setInterval(checkStatusChange, 5000);
    }
    return () => {
      pollingRef.current && clearInterval(pollingRef.current);
    }
  }, []);

  const checkStatusChange = async () => {
    const { errors, jifitiCard } = await bdayFetch(`/api/1/card/send/gift${updateSearch({ 'jifitiCardId': jifitiCardId, 'cardSendId': cardSendId, 'cardSendRecipientId': cardSendRecipientId })}`);
    if (errors?.length > 0) {
      // There was a problem, stop polling
      pollingRef.current && clearInterval(pollingRef.current);
    } else if (jifitiCard?.status) {
      setStatus(jifitiCard.status);
      if (jifitiCard.status !== 'pending') {
        pollingRef.current && clearInterval(pollingRef.current);
      }
    }
  }

  return (
    <div className={`card-create-gift-recipient-card-container ${className}`}>
      <GiftCardImage className="recipient-gift-card-image" giftCard={giftCard}/>
      <span className="recipient-gift-card-retailer-name">{productRetailerName}</span>
      <span className="recipient-gift-card-value">{getFormattedPrice(productPrice, currencyCode)}</span>
      <span className={`recipient-gift-card-status ${status}`}>
        {status === 'pending' && <div className="pending-animation"/>}
        {status === 'success' && <BaIconCheckCircle/>}
      </span>
    </div>
  );
}


CardCreateRecipientGiftCard.propTypes = {
  className: PropTypes.string,
  cardSend: PropTypes.object.isRequired,
  cardSendRecipient: PropTypes.object.isRequired,
  giftCard: PropTypes.object.isRequired
};

CardCreateRecipientGiftCard.defaultProps = {
  className: ''
};

export default CardCreateRecipientGiftCard;
